import { render, staticRenderFns } from "./DevSupport.vue?vue&type=template&id=14b00626&"
import script from "./DevSupport.vue?vue&type=script&lang=js&"
export * from "./DevSupport.vue?vue&type=script&lang=js&"
import style0 from "./DevSupport.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports